import {
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  FormControl,
  FormLabel,
  Text,
  ChakraProps,
} from "@chakra-ui/react";
import React, { FC } from "react";
import { FieldRenderProps } from "react-final-form";
import { DefaultFieldProps } from "../../types";

interface NumberFieldProps extends DefaultFieldProps {
  min?: number;
  max?: number;
  defaultVal?: number;
  numberInputProps?: ChakraProps;
}

const NumberField: FC<FieldRenderProps<NumberFieldProps & any>> = (props) => {
  const {
    min,
    max,
    defaultVal,
    formGroupProps,
    labelProps,
    errorProps,
    label,
    meta,
    input,
    numberInputProps = {
      size: "md",
    },
  } = props;

  return (
    <FormControl {...formGroupProps} position="relative">
      <FormLabel {...labelProps}>{label}</FormLabel>

      <NumberInput
        min={min}
        max={max}
        defaultValue={defaultVal}
        {...input}
        {...numberInputProps}
      >
        <NumberInputField rounded="sm" />
        <NumberInputStepper>
          <NumberIncrementStepper />
          <NumberDecrementStepper />
        </NumberInputStepper>
      </NumberInput>
      {meta.error && meta.touched && (
        <Text
          {...errorProps}
          color="red.300"
          fontSize="sm"
          textAlign="end"
          mx="3"
          position="absolute"
          right={0}
        >
          {meta.error}
        </Text>
      )}
    </FormControl>
  );
};

export default NumberField;
